var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSendRaiFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.56 6.838C2.828 4.855 4.901 3 6.792 3.946l19.936 9.969c1.72.86 1.72 3.313 0 4.173L6.793 28.056c-1.891.945-3.964-.91-3.234-2.893L6.566 17h5.768a1 1 0 000-2H6.566L3.559 6.838z",
    fill: "#3D3D3D"
  })));
}

export default SvgIconSendRaiFilled;